import WrapWithCopy from "@/components/WrapWithCopy.vue";
import AppPopover from "@/components/AppPopover";
import AppIcon from "@/components/AppIcon";
import Popper from "vue3-popper";
import AppTd from "@/components/AppTd";
import WrapWithStatusIcon from "@/components/seo/WrapWithStatusIcon.vue";
export default {
  name: "SeoSearchTermsCell",
  props: {
    item: Object,
    isCopying: {
      type: Boolean,
      default: false
    },
    showPopover: Boolean,
    uid: String,
    index: Number
  },
  emits: ["onEdit", "onPaste", "isCopied", "onCopyingHover", "onCopyingHoverLeave"],
  components: {
    AppIcon,
    AppPopover,
    WrapWithCopy,
    Popper,
    AppTd,
    WrapWithStatusIcon
  },
  data() {
    return {
      isClicked: false
    };
  },
  watch: {
    is_copying() {
      if (!this.is_copying) {
        this.isClicked = this.is_copying;
      }
    }
  },
  methods: {
    handleCopied() {
      const refEl = this.$refs[this.uid];
      if (!refEl) {
        return;
      }
      this.isClicked = true;
      this.$emit("isCopied", refEl);
    }
  }
};